<template>
	<div
		class="bg-white shadow overflow-hidden pl-3 pr-3 sm:pr-3 pt-2 pb-3 rounded-lg sm:rounded-xl cursor-pointer"
		:class="[
			isActive ? 'ring-2' : '',
			offer.trade == 'SELL' ? 'ring-green-500' : 'ring-orange-500',
		]"
	>
		<!-- <div v-if="offer.trade == 'SELL'" class="text-green-500 text-xs">{{__('Sell Offer') }}</div>
        <div v-else class="text-orange-500 text-xs">{{__('Buy Offer') }}</div> -->

		<div class="flex gap-x-2 flex-shrink-0 pt-0.5 mb-1">
			<div
				v-if="offer.trade == 'SELL'"
				class="bg-green-500 rounded-full w-4 h-4"
			></div>
			<div v-else class="bg-orange-500 w-4 h-4"></div>
			<div
				class="font-medium text-xs whitespace-nowrap"
				:class="offer.trade == 'SELL' ? 'text-green-500' : 'text-orange-500'"
			>
				{{ offer.trade == "BUY" ? __("Buy Offer") : __("Sell Offer") }}
			</div>
			<crop-timeago
				class="ml-auto text-xs text-gray-500 truncate"
				v-bind:date="offer.updated_at"
			/>
		</div>

		<div class="relative flex gap-x-2">
			<div class="flex-grow min-w-0">
				<div class="flex items-baseline justify-between mb-2 w-full space-x-2">
					<h3
						class="font-medium text-gray-900 flex-shrink flex items-baseline min-w-0 space-x-1"
					>
						<span class="whitespace-nowrap">
							{{
								$cropOptions.getLocalizedLabel(
									offer.product.grade,
									$cropOptions.productGradeOptions
								)
							}}
						</span>
						<span>–</span>
						<span class="flex-shrink truncate"
							>{{ __("Harvest") }}
							{{ offer.product.harvest || __("n.a.") }}</span
						>
						<!-- <span v-if="offer.trade == 'SELL'" class="text-green-500 text-xs">{{__('Sell Offer') }}</span>
                        <span v-else class="text-orange-500 text-xs">{{__('Buy Offer') }}</span> -->
					</h3>
					<!-- <span class="text-red-500" v-if="isActive">AKTIV</span> -->
				</div>

				<table class="mb-1.5 text-gray-500 text-sm border-collapse">
					<tr v-if="!(offer.trade === 'BUY' && user && user.type == 'FARMER')">
						<td class="p-0 pr-2 align-top">{{ __("Location") }}:</td>
						<td class="p-0 truncate">
							{{
								$cropOptions.getLocalizedLabel(
									offer.location.mode,
									$cropOptions.locationModeOptions
								)
							}}
							{{ offer.location.address.city }}
							({{
								(result.distance_km_road || result.distance_km).toFixed(0) +
								" km"
							}})
						</td>
					</tr>
					<tr
						v-else-if="offer.trade === 'BUY' && user && user.type == 'FARMER'"
					>
						<td class="p-0 pr-2 align-top">{{ __("Location") }}:</td>
						<td class="p-0 truncate">
							<span
								v-if="
									(offer.location.mode == 'DAP' &&
										offer.location.optional_transport) ||
									(offer.location.mode == 'FCA' &&
										!offer.location.optional_transport)
								"
							>
								{{
									$cropOptions.getLocalizedLabel(
										"FCA",
										$cropOptions.locationModeOptions
									)
								}}
							</span>
							<span
								v-else-if="
									offer.location.mode == 'DAP' &&
									!offer.location.optional_transport
								"
							>
								{{
									$cropOptions.getLocalizedLabel(
										"DAP",
										$cropOptions.locationModeOptions
									)
								}}
							</span>
							<span v-else>
								{{
									$cropOptions.getLocalizedLabel(
										offer.location.mode,
										$cropOptions.locationModeOptions
									)
								}}
								{{ offer.location.address.city }}
							</span>
							<span
								v-if="
									offer.location.mode == 'DAP' &&
									offer.location.optional_transport &&
									user
								"
							>
								{{ user.address__city }}
							</span>
							<span
								v-else-if="
									(offer.location.mode == 'DAP' &&
										!offer.location.optional_transport) ||
									(offer.location.mode == 'FCA' &&
										!offer.location.optional_transport)
								"
							>
								{{ offer.location.address.city }}
								<span
									v-if="
										offer.location.mode == 'DAP' &&
										!offer.location.optional_transport
									"
								>
									({{
										(result.distance_km_road || result.distance_km).toFixed(0) +
										" km"
									}})
								</span>
							</span>
						</td>
					</tr>
					<tr>
						<td class="p-0 pr-2 align-top">{{ __("Fulfilment Date") }}:</td>
						<td class="p-0">
							{{ $cropOptions.dateToString(offer, locale, true) }}
						</td>
					</tr>
					<tr>
						<td class="p-0 pr-2 align-top text-gray-900 font-semibold">
							{{ __("Quantity") }}:
						</td>
						<td class="p-0 text-gray-900">
							<span class="font-semibold">{{ offer.qty.mt }} t </span>
							<span>({{ __("Partial quantity possible") }})</span>
						</td>
					</tr>
					<tr>
						<td
							class="p-0 pr-2 align-top font-semibold"
							:class="canSeePrice ? 'text-gray-900' : 'text-red-500'"
						>
							<span v-if="offer.trade == 'BUY'"> {{ __("Price") }}: </span>
							<span v-else> {{ __("Asking price") }}: </span>
						</td>
						<td class="p-0 text-gray-900 font-semibold">
							<span v-if="canSeePrice">
								<span
									v-if="
										user &&
										user.type == 'FARMER' &&
										offer.trade == 'BUY' &&
										offer.location.mode == 'DAP' &&
										offer.location.optional_transport &&
										result.price_estimate
									"
								>
									{{
										result.price_estimate
											? $cropOptions.formatLocalizedNumber(
													result.price_estimate
											  ) + " €/t"
											: __("n.a.")
									}}
								</span>
								<span v-else>
									{{
										offer.price.mt
											? $cropOptions.formatLocalizedNumber(offer.price.mt) +
											  " €/t"
											: __("n.a.")
									}}
								</span>
							</span>
							<span v-else class="text-red-500">
								{{ __("Only for active users") }}
							</span>
						</td>
					</tr>
				</table>

				<!-- CTA -->
				<div :class="canSeePrice ? 'flex xl:-mt-4' : 'flex'">
					<ui-button
						v-if="activeThreadUrl"
						type="primary"
						class="ml-auto text-sm"
						v-on:click="$inertia.visit(activeThreadUrl)"
						>{{ __("Go to negotiation") }}</ui-button
					>
					<ui-button
						v-else
						type="primary"
						class="ml-auto text-sm"
						v-on:click="maybeBid()"
					>
						{{
							offer.trade == "BUY"
								? __("Go to Buy Offer")
								: __("Go to Sell Offer")
						}}
					</ui-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		result: {
			type: Object,
			required: true,
		},
		isActive: {
			type: Boolean,
			required: true,
		},
		user: {
			type: Object,
			required: false,
		},
	},
	data() {
		return {
			offer: this.result.offer,
			acl: this.$inertia.page.props.acl,
		};
	},
	methods: {
		maybeBid() {
			if (this.acl.can_trade) {
				this.$bus.$emit(
					"toggle-iframe-modal",
					this.$route("bid.create", {
						targetType: this.offer.trade,
						targetId: this.offer.id,
					})
				);
			} else {
				this.$bus.$emit("toggle-permission-denied-modal");
			}
		},
	},
	computed: {
		canSeePrice() {
			return this.acl.see_price;
		},
		activeThreadUrl() {
			let t = this.result.threads.filter(
				(t) => t.status == "UNDER_NEGOTIATION"
			);
			if (t.length > 0) {
				return this.$route("threads", { active_id: this.result.threads[0].id });
			}
		},
	},
};
</script>

<style scoped>
/* table {
        border-spacing: .25rem 0;
    } */
/* table td {
        padding: 0;
    } */
</style>
